import { Dialog } from "primereact/dialog";
import React from "react";
import styles from "./DetailPopup.module.scss";

interface DetailPopupProps {
  isOpen: boolean;
  onClose: () => void;
  data: Record<string, string>;
  header?: string;
}

const DetailPopup: React.FC<DetailPopupProps> = ({
  isOpen,
  onClose,
  data,
  header = "Detaylar",
}) => {
  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      modal
      className={styles.customDialog}
      dismissableMask
      showHeader={false}
    >
      <div className={styles.customHeader}>
        <span>{header}</span>
        <button className={styles.customCloseButton} onClick={onClose}>
          ✕
        </button>
      </div>
      <div className={styles.content}>
        {Object.entries(data).map(([key, value]) => (
          <div key={key} className={styles.row}>
            <span className={styles.label}>{key}:</span>
            <p
              className={styles.value}
              dangerouslySetInnerHTML={{
                __html: value? value.replace(/\r\n/g, "<br/>"):"",
              }}
            />
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default DetailPopup;
